<div class="app-global-message">
  <div *ngIf="showBanner" class="global-message-wrapper">
    <div class="global-message alert-warning">
      <span id="global-banner-message" data-automation="global-banner-message">
        {{ message }}
      </span>
      <mat-icon class="fill-primary pointer mr-2" (click)="hideBanner()">
        close
      </mat-icon>
    </div>
  </div>
</div>
